import { CButton, CFormInput, CFormLabel, CFormTextarea } from "@coreui/react";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import AxiosInstance from "src/components/Axios";
import { toast } from 'react-toastify'
import { useNavigate } from "react-router-dom";

export default function PlanStages() {
   // хто увійшов
   const role = localStorage.getItem('user_role')
   // console.log(role)


   //для селекта
   const [stageTitle, setStageTitle] = useState('')

   //для нового етапу в інпуті
   const [stageInputText, setStageInputText] = useState('')
   //для нового етапу в інпуті
   const [stageDescriptionText, setStageDescriptionText] = useState('')
   //для оновлення селекта
   const [reloadKey, setReloadKey] = useState(0)
   const navigate = useNavigate()

   //стилі для селекту
   const customStyles = {
      menuList: (provided) => ({
         ...provided,
         maxHeight: '200px',
         overflowY: 'auto',
      }),
   };



   const loadOptions = async (inputValue = '') => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/work_stages_lists?name=${inputValue}`
            // , header
         ).then((response) => {
            console.log('response.data', response.data)
            const options = response.data['hydra:member']?.map((result) => ({
               label: result.name,
               value: result.id,
            })
            );
            console.log('options', options)
            return options

         });
      } else {
         // if (userData.id) {
         //    return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
         //       return response.data.map((result) => ({
         //          label: result.name,
         //          value: result.id,
         //       }));
         //    });
         // }
         return []
      }
   }

   // функція для додавання етапу
   function addItem() {
      if (stageInputText === '' || stageDescriptionText === '') return

      const send_data = {
         name: stageInputText,
         description: stageDescriptionText
      }

      AxiosInstance.post(`/work_stages_lists`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         // return response.data.map((result) => ({
         //    label: result.name,
         //    value: result.id,
         // }));
         toast.success('Новий етап роботи додано')
         setStageInputText('')
         setStageDescriptionText('')
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Новий етап роботи не додано'));

   }

   // console.log('loadOptions', loadOptions)

   if (role !== 'ROLE_ADMIN') { return }

   return (
      <>
         {/* Частина з реакт селектом этапів */}
         <div>
            <h2>Список етапів</h2>
            <AsyncSelect
               key={reloadKey}
               cacheOptions
               loadOptions={loadOptions}
               defaultOptions
               // value={partnerFilterSearch}
               // onChange={handleChangePartner}
               className="flex-grow-1"
               placeholder="Этапи робіт"
               styles={customStyles}
            />
         </div>
         {/* Частина для додавання нового етапу до довідника з інпутом для назви */}
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput1">Введіть назву етапу</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput1"
               // defaultValue="Введіть назву нового етапу"
               value={stageInputText}
               onChange={(e) => setStageInputText(e.target.value)}
               placeholder="Введіть назву етапу"
               autoComplete="off"
            />
         </div>
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Введіть опис етапу</CFormLabel>
            <CFormTextarea
               type="text"
               id="exampleFormControlInput2"
               // defaultValue="Введіть опис нового етапу"
               value={stageDescriptionText}
               onChange={(e) => setStageDescriptionText(e.target.value)}
               placeholder="Введіть опис етапу"
               autoComplete="off"
            />
            <CButton className="mt-3" onClick={addItem} >Додати</CButton>
         </div>
      </>
   )
}